import {
  isSpecialCardSet,
  isSupportedCardSet,
} from '@sorare/core/src/lib/cardSets';
import { getSetBackground } from '@sorare/core/src/set';

type Props = {
  set: Nullable<string>;
};

export const CollectionSetBackground = ({ set }: Props) => {
  if (!isSupportedCardSet(set)) {
    return null;
  }
  if (isSpecialCardSet(set)) {
    return <div style={getSetBackground(set)} />;
  }
  return null;
};
